import React from "react";
import Skill from "./skill";
import { useSelector } from "react-redux";

const SkillsList = ({ activeSkill, setActiveSkill }) => {
  const skills = useSelector((state) => state.publicUser.skills);

  return (
    <React.Fragment>
      {skills.map((skill, index) => {
        if (index < 3) {
          return (
            <Skill
              skill={skill}
              index={skill.id}
              key={skill.id || index}
              activeSkill={activeSkill}
              setActiveSkill={setActiveSkill}
            />
          );
        }
      })}
    </React.Fragment>
  );
};

export default SkillsList;
